export default __webpack_public_path__ + "assets/workflow-comparison2.a8838180.png";